export default __webpack_public_path__ + "static/media/feature-2-images.b6343146.svg";